const StatusBadge = ({ status, className = '' }) => {
    const getStatusStyles = (status) => {
        const normalizedStatus = status?.toLowerCase().replace('_', ' ') || '';
        
        if (normalizedStatus.includes('selected') || normalizedStatus.includes('approved') || normalizedStatus.includes('active')) {
            return 'bg-green-100 text-green-800 border-green-300';
        }
        if (normalizedStatus.includes('rejected') || normalizedStatus.includes('denied')) {
            return 'bg-red-100 text-red-800 border-red-300';
        }
        if (normalizedStatus.includes('pending') || normalizedStatus.includes('under review') || normalizedStatus.includes('waiting')) {
            return 'bg-yellow-100 text-yellow-800 border-yellow-300';
        }
        if (normalizedStatus.includes('submitted') || normalizedStatus.includes('completed')) {
            return 'bg-blue-100 text-blue-800 border-blue-300';
        }
        return 'bg-gray-100 text-gray-800 border-gray-300';
    };

    return (
        <span className={`text-xs px-2 py-1 rounded font-medium border ${getStatusStyles(status)} ${className}`}>
            {status?.replace('_', ' ') || 'Unknown'}
        </span>
    );
};

export default StatusBadge;

